import React, { Suspense, useMemo } from 'react';
import Typography from '@mui/material/Typography';
import CloseIconMui from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { Preloader } from '#component/preloader';
import DeviceEvents from '#component/device/overview/events';
import {
  DialogAppBar,
  CloseIcon
} from '#component/device/overview/styles';

const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);
const DeviceMeasurements = React.lazy(() => import('#component/device/overview/measurements'));
const EVENTS_TAB = 100;
const MAP_TAB = 90;

function DialogWithMeasurements(props) {
  const {
    isInRange,
    chartDateRange,
    MapComponent,
    parentState,
    handleClose,
    identifiers,
    setChart,
    devices,
    history,
    account,
    device,
    events,
    match,
    open,
    tab,
    setClickedEvents
  } = props;

  const identifier = identifiers[tab];
  const memoEvents = useMemo(() => [...events], [events]);

  const getDialogTitle = () => {
    switch (tab) {
      case EVENTS_TAB: {
        return 'EVENTS';
      }
      case MAP_TAB: {
        return 'MAP';
      }
      default:
        return identifier?.toUpperCase();
    }
  };

  return (
    <Dialog
      TransitionComponent={Transition}
      onClose={handleClose}
      open={open}
      fullScreen
      className="cluster"
    >
      <DialogAppBar>
        <Toolbar>
          <CloseIcon
            aria-label="close"
            color="inherit"
            edge="start"
            onClick={handleClose}
          >
            <CloseIconMui />
          </CloseIcon>
          <Typography variant="h5">
            {getDialogTitle()}
          </Typography>
        </Toolbar>
      </DialogAppBar>
      {identifier && (!parentState[`${identifier}Loading`] ? (
        <Suspense fallback={<Preloader />}>
          <DeviceMeasurements
            isInRange={isInRange}
            identifier={identifier}
            selectedDevices={devices}
            range={chartDateRange}
            events={device.events}
            setChart={setChart}
            match={match}
            isMobile
            clickEvents={setClickedEvents}
          />
        </Suspense>
      ) : (
        <Preloader />
      ))}
      {tab === EVENTS_TAB && (
      <DeviceEvents
        events={memoEvents}
        history={history}
        account={account}
      />
      )}
      {tab === MAP_TAB && MapComponent}
    </Dialog>

  );
}

export default DialogWithMeasurements;
